import React, { FC } from 'react';
import styles from './entity_block_components.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';

export const EntityBlock: FC<{ id?: string }> = ({ children, id }) => (
  <div id={id} className={styles.block}>
    {children}
  </div>
);

export const EntityBlockTitle: FC = ({ children }) => (
  <h3 className={styles.title}>{children}</h3>
);

export const EntityBlockSubtitle: FC = ({ children }) => (
  <div className={styles.subtitle}>{children}</div>
);

export const EntityBlockSubtitleText: FC = ({ children }) => (
  <div className={styles.subtitleText}>{children}</div>
);

export const EntityBlockInfoIcon: FC = () => (
  <MaterialIcon name="info_outline" className={styles.icon} />
);
